import { render } from "./DataRole.vue?vue&type=template&id=32d20462&scoped=true"
import script from "./DataRole.vue?vue&type=script&lang=js"
export * from "./DataRole.vue?vue&type=script&lang=js"

import "./DataRole.vue?vue&type=style&index=0&id=32d20462&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d20462"]])

export default __exports__